import React, { FC, memo } from "react";

import {
  ResponsiveModal,
  IResponsiveModalProps,
} from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { Icon } from "@UI/Components/Icon/Icon";
import { CircleExclamation } from "@UI/Components/Icons/CicleExclamation";
import { VStack } from "@UI/Components/Stack/Stack";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "./messages";

export type TStaleTaskReason = "assigned" | "full" | "expired";

const titleMessageByReason: Record<TStaleTaskReason, typeof messages[keyof typeof messages]> = {
  assigned: messages["serviceRequest.staleTaskModal.title.assigned"],
  full: messages["serviceRequest.staleTaskModal.title.full"],
  expired: messages["serviceRequest.staleTaskModal.title.expired"],
};

export interface IStaleTaskModalProps
  extends Pick<IResponsiveModalProps, "isOpen" | "onClose"> {
  reason: TStaleTaskReason;
  seeMoreJobsUrl: string;
}

export const StaleTaskModal: FC<IStaleTaskModalProps> = memo(
  ({ reason, isOpen, onClose, seeMoreJobsUrl }) => {
    return (
      <ResponsiveModal isOpen={isOpen} onClose={onClose}>
        <VStack spacing="4" textAlign="center" py="2">
          <Icon as={CircleExclamation} w="12" h="12" color="gray.400" />
          <Heading as="h4" fontSize="lg">
            <FormattedMessage {...titleMessageByReason[reason]} />
          </Heading>
          <Text color="gray.500">
            <FormattedMessage {...messages["serviceRequest.staleTaskModal.subtext"]} />
          </Text>
          <Button w="full" size="lg" colorScheme="seaGreen" as="a" href={seeMoreJobsUrl}>
            <FormattedMessage {...messages["serviceRequest.staleTaskModal.cta"]} />
          </Button>
        </VStack>
      </ResponsiveModal>
    );
  }
);

StaleTaskModal.displayName = "StaleTaskModal";
